module.exports = __webpack_public_path__ + "img/bd.91c34273.svg";